export const DEMAND_PARTNERS_TYPES = {
  GET_ALL_DEMAND_PARTNERS: 'GET_ALL_DEMAND_PARTNERS_BEGIN',
  GET_ALL_DEMAND_PARTNERS_SUCCESS: 'GET_ALL_DEMAND_PARTNERS_SUCCESS',
  GET_ALL_DEMAND_PARTNERS_FAILURE: 'GET_ALL_DEMAND_PARTNERS_FAILURE',
  GET_DEFAULT_SETTINGS: 'GET_DEFAULT_SETTINGS_BEGIN',
  GET_DEFAULT_SETTINGS_SUCCESS: 'GET_DEFAULT_SETTINGS_SUCCESS',
  GET_DEFAULT_SETTINGS_FAILURE: 'GET_DEFAULT_SETTINGS_FAILURE',
};
